import React from 'react';
import { OpenAiOptions } from './OpenAiOptions';
import { BedrockOptions } from './BedrockOptions';

interface EmbeddingOptionsProps {
  selectedProvider: string;
  settings: any;
  onSettingChange: (key: string, value: string) => void;
}

export const EmbeddingOptions: React.FC<EmbeddingOptionsProps> = ({
  selectedProvider,
  settings,
  onSettingChange
}) => {
  // Renderiza as opções específicas baseado no provedor selecionado
  switch (selectedProvider) {
    case 'openai':
      return (
        <OpenAiOptions 
          settings={settings} 
          onSettingChange={onSettingChange} 
        />
      );
    
    case 'bedrock':
      return (
        <BedrockOptions 
          settings={settings} 
          onSettingChange={onSettingChange} 
        />
      );
    
    case 'cohere':
      return (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Chave da API Cohere
              </label>
              <input
                type="password"
                value={settings?.CohereApiKey || ''}
                onChange={(e) => onSettingChange('CohereApiKey', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="chave_cohere..."
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                Sua chave de API da Cohere
              </p>
            </div>
          </div>
        </div>
      );
    
    default:
      return (
        <div className="text-center py-8 text-gray-500">
          Selecione um provedor de embedding para ver as opções de configuração
        </div>
      );
  }
};



